import CopyButton from "@components/buttons/CopyButton";
import React from "react";

interface LabelRowProps {
  label: string;
  value?: string;
  isCopy?: boolean;
  valueComp?: React.ReactNode;
  alignment?: "row" | "col";
  isRedirect?: boolean;
  redirectLink?: string;
}

const LabelRow: React.FC<LabelRowProps> = ({
  label,
  value,
  isCopy = false,
  valueComp,
  alignment = "row",
  isRedirect = false,
  redirectLink,
}) => {
  const isColumnLayout = alignment === "col";

  const handleRedirect = () => {
    if (redirectLink) {
      window.open(redirectLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={`flex ${
        isColumnLayout ? "flex-col gap-[4px]" : "flex-row justify-between"
      } items-${isColumnLayout ? "start" : "center"}`}>
      <div
        className={`flex ${
          isColumnLayout ? "w-full flex-row justify-between" : ""
        }`}>
        <span className="text-text-base text-[12px] font-normal">{label}</span>

        <div className="flex items-center gap-[6px]">
          {isColumnLayout && isCopy && value && (
            <CopyButton
              copyText={value}
              copyMessage={`${label} copied to clipboard`}
            />
          )}
        </div>
      </div>

      {valueComp ? (
        valueComp
      ) : (
        <div className="flex flex-row items-center gap-[4px]">
          <span className="font-normal text-[12px] text-text-base truncate p-0 m-0">
            {value && value.length > 0 ? value : "- -"}
          </span>

          {isRedirect && !isColumnLayout && redirectLink && (
            <button
              onClick={handleRedirect}
              className="flex items-center justify-center text-text-button-primary">
              <span className="material-symbols-outlined text-[12px]">
                open_in_new
              </span>
            </button>
          )}

          {isCopy && !isColumnLayout && (
            <CopyButton
              copyText={value || ""}
              copyMessage={`${label} copied to clipboard`}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default LabelRow;
